import { AppEnvEnum } from '@ulysses-inc/harami_api_client'

export const appEnv = {
  isLocal: import.meta.env['VITE_APP_ENV'] === AppEnvEnum.LOCAL,
  isDevelopment: import.meta.env['VITE_APP_ENV'] === AppEnvEnum.DEV,
  isProduction: import.meta.env['VITE_APP_ENV'] === AppEnvEnum.PRODUCTION,
}
